var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "reservation-member-card" }, [
    _vm.member.avatar
      ? _c("img", {
          staticStyle: { width: "200px" },
          attrs: { src: _vm.getAvatarUrl(), alt: "Avatar" },
        })
      : _c("div", { staticClass: "no-avatar" }, [
          _vm._v(_vm._s(_vm.$t("calendar.noAvatar"))),
        ]),
    _vm._v(" "),
    _c("div", { staticClass: "member-info" }, [
      _c("h3", [_vm._v(_vm._s(_vm.member.name))]),
      _vm._v(" "),
      _c("p", [_vm._v(_vm._s(_vm.member.title))]),
      _vm._v(" "),
      _c("p", [_vm._v(_vm._s(_vm.member.description))]),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "member-actions" },
      [
        _c(
          "SupsisButton",
          {
            attrs: { ghost: "" },
            on: {
              click: function ($event) {
                return _vm.$emit("edit")
              },
            },
          },
          [_vm._v(_vm._s(_vm.$t("message.edit")))]
        ),
        _vm._v(" "),
        _c(
          "SupsisButton",
          {
            attrs: { danger: "" },
            on: {
              click: function ($event) {
                return _vm.$emit("delete")
              },
            },
          },
          [_vm._v(_vm._s(_vm.$t("message.delete")))]
        ),
        _vm._v(" "),
        _c(
          "SupsisButton",
          {
            on: {
              click: function ($event) {
                return _vm.$emit("move-up")
              },
            },
          },
          [_vm._v(_vm._s(_vm.$t("message.moveLeft")))]
        ),
        _vm._v(" "),
        _c(
          "SupsisButton",
          {
            on: {
              click: function ($event) {
                return _vm.$emit("move-down")
              },
            },
          },
          [_vm._v(_vm._s(_vm.$t("message.moveRight")))]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }